import { WorksheetImagesAndRemarksSection, WorksheetTestedBySection } from 'Components/Worksheets/Core';
import { ListFieldSection, PageSection, SectionGroup } from '../../../Layout';
import ids from '../../QestIds';

import { NamePrefixModifier } from 'Components/Core/InjectedPropsContext';
import {
  CompactionDataSection,
  CompactionEquipmentSection,
  CompactionWaterContentDeterminationEquipmentSection,
  MetricCompactionCwdSection,
  TestFractionSpecificGravitySection,
} from '../Shared';
import {
  AstmMetricCompactionWaterContentDeterminationGridSection,
  AstmMetricResultsSection,
  AstmPreparationSection,
  OversizeCorrectionSection,
  OversizeDeterminationSection,
} from './Sections';

const qestIds = [ids.maximumDryDensity.ASTM_D_1557.rev2012_metric, ids.maximumDryDensity.ASTM_D_698.rev2012e2_metric];

let AstmMetricMddWorksheet = () => {
  return (
    <>
      <AstmPreparationSection />
      <OversizeDeterminationSection />
      <OversizeCorrectionSection />

      <NamePrefixModifier appendNamePrefix="TestFractionSpecificGravity">
        <TestFractionSpecificGravitySection />
      </NamePrefixModifier>

      <PageSection heading="Compaction">
        <CompactionEquipmentSection />
        <SectionGroup heading="Compaction Data">
          <MetricCompactionCwdSection />
          <ListFieldSection name="TestPortions" />
          <CompactionDataSection />
        </SectionGroup>
        <SectionGroup heading="Water Content Determination">
          <CompactionWaterContentDeterminationEquipmentSection />
          <AstmMetricCompactionWaterContentDeterminationGridSection />
        </SectionGroup>
      </PageSection>

      <PageSection>
        <WorksheetTestedBySection />
      </PageSection>
      <AstmMetricResultsSection />
      <PageSection heading="Images and Remarks">
        <WorksheetImagesAndRemarksSection />
      </PageSection>
    </>
  );
};

AstmMetricMddWorksheet.qestIds = qestIds;

export default AstmMetricMddWorksheet;
